import { apiRequest } from './api';

export interface FileUploadResponse {
    fileName: string;
    url: string;
    fileSize?: number;
    contentType?: string;
    mediaId?: string;
}

export interface FileUploadRequest {
    file: File;
}

export interface DeleteFileRequest {
    fileUrl: string;
}

export interface DeleteFileResponse {
    message: string;
    fileName: string;
}

class FileUploadApiService {
    async uploadFile(file: File): Promise<FileUploadResponse> {
        const formData = new FormData();
        formData.append('file', file);

        const result = await apiRequest<FileUploadResponse>('/FileUpload/UploadFile', {
            method: 'POST',
            auth: true,
            headers: {
                // Remove Content-Type para permitir que o browser defina o boundary do FormData
            },
            body: formData,
        });

        if (!result.success) {
            throw new Error(result.error || 'Falha ao fazer upload do arquivo');
        }

        return result.data!;
    }

    async deleteFile(fileUrl: string): Promise<DeleteFileResponse> {
        const result = await apiRequest<DeleteFileResponse>('/FileUpload/DeleteFile', {
            method: 'DELETE',
            auth: true,
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ fileUrl }),
        });

        if (!result.success) {
            throw new Error(result.error || 'Falha ao deletar o arquivo');
        }

        return result.data!;
    }
}

export const fileUploadApi = new FileUploadApiService();
